export enum AssignmentSearchDistinctField {
  Controller = 'Контролер',
  Registrar = 'Регистратор',
  DocumentType = 'Тип',
  Project = 'Проект',
}

export const ASSIGNMENT_SEARCH_DISTINCT_FIELDS = Object.values(AssignmentSearchDistinctField);

export const ASSIGNMENT_SEARCH_EXECUTOR_DISTINCT_FIELD = 'Исполнитель';
